import axios from "axios";
import { APIAdapter } from "../../../helpers/api_helper";

const api = new APIAdapter();

  export const updateMarchandById = async (merchandId, data) => {
    try {
      const response = await api.update(`/merchants/${merchandId}`, data);
      return response;
    } catch (error) {
      throw error;
    }
  };
    export const getMesCopmtes = async (id) => {
      try {
           const response = await axios.get(`${process.env.REACT_APP_API_TRANSACTION}/pay-out-account/mobile/by-merchant/${id}`);
        return response.data;
        
      } catch (error) {
        throw error;
      }
  };
     export const updateCompte = async ({id, payload}) => {
      try {
           const response = await axios.put(`${process.env.REACT_APP_API_TRANSACTION}/pay-out-account/mobile/${id}`,
           payload
          );
        return response.data;
      } catch (error) {
        throw error;
      }
  };
   export const deleteCompte = async (id) => {
      try {
        const response = await axios.delete(`${process.env.REACT_APP_API_TRANSACTION}/pay-out-account/${id}`,);
        return response.data;
      } catch (error) {
        throw error;
      }
  };
export const addCompte = async (payload) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_TRANSACTION}/pay-out-account/create/mobile`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Erreur API:", error);
    throw error;
  }
};



